import { useCallback, useEffect, useState } from "react";

/* ---------------------------------------------------------------
   "Hide balance" toggle for the profile screen. Applies to every
   user of this device/browser (no account-scoping, no backend call)
   — it's a pure client-side display preference persisted to
   localStorage, so it survives reloads and stays in sync across
   any tabs the app is open in.
------------------------------------------------------------------ */
const STORAGE_KEY = "pj_balance_hidden";

function readStored() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch (e) {
    return false;
  }
}

function writeStored(hidden) {
  try {
    if (hidden) localStorage.setItem(STORAGE_KEY, "1");
    else localStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
}

export function useHiddenBalance() {
  const [hidden, setHidden] = useState(readStored);

  // keep in sync if the value changes in another tab/window
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setHidden(e.newValue === "1");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggle = useCallback(() => {
    setHidden((prev) => {
      const next = !prev;
      writeStored(next);
      return next;
    });
  }, []);

  return [hidden, toggle];
}
